export interface HttpRequest {
  path: string;
  method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  body?: unknown;
  token?: string;
  signal?: AbortSignal;
}

export interface HttpPort {
  request<T>(input: HttpRequest): Promise<T>;
}

interface ErrorPayload {
  error?: string;
  message?: string;
  errors?: Array<{ msg?: string; message?: string }>;
}

export class HttpError extends Error {
  constructor(message: string, readonly status: number) {
    super(message);
    this.name = "HttpError";
  }
}

export function createFetchHttp(base = "/api"): HttpPort {
  return {
    async request<T>(input: HttpRequest): Promise<T> {
      const response = await fetch(`${base}${input.path}`, {
        method: input.method ?? "GET",
        credentials: "include",
        headers: {
          ...(input.body === undefined ? {} : { "Content-Type": "application/json" }),
          ...(input.token && !["GET", "HEAD"].includes(input.method ?? "GET") ? { "X-CSRF-Token": input.token } : {})
        },
        body: input.body === undefined ? undefined : JSON.stringify(input.body),
        signal: input.signal
      });
      const payload = await response.json().catch(() => ({})) as T & ErrorPayload;
      if (!response.ok) {
        const validationMessage = payload.errors?.map((item) => item.msg ?? item.message).filter(Boolean).join(" ");
        throw new HttpError(payload.error ?? payload.message ?? validationMessage ?? "Anfrage fehlgeschlagen", response.status);
      }
      return payload;
    }
  };
}
